import { useAnalytics } from "@segment/analytics-react";

export function useTrackEvent() {
  const { track } = useAnalytics();

  const handleTrack = (eventName: string) => track(eventName);
  return { handleTrack };
}
